angular.module('cfn').directive('dDateFilter', dDateFilter);

dDateFilter.$inject = ['$dialog', '$filter'];
function dDateFilter($dialog, $filter) {
  var toDateString = function(date) {
    return $filter('date')(date, 'shortDate');
  };

  return {
    restrict: 'E',
    scope: {
      model: '=',
      class: '@',
      showSelection: '@',
      hideDay: '@',
      hideTimeFrame: '@',
      hideRemove: '@',
      placeholder: '@',
      change: '&'
    },
    replace: true,
    template:
      '<input type="text" ng-click="showPopup()" placeholder="{{placeholder}}" cfn-enter-tab class="{{class}} cfn-input-date" value="{{dateSelection}}"/>',
    link: function(scope, element, attr) {
      var shouldUpdateText = attr.showSelection !== 'false',
        shouldHideDaySelector = attr.hideDay === 'true',
        shouldHideTimeFrameSelector = attr.hideTimeFrame === 'true',
        shouldHideRemoveSelector = attr.hideRemove === 'true';

      /**
       * reset time values to 0 (hours, minutes, seconds, milliseconds)
       * @param {Date} date
       */
      function resetTimeToZero(date) {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
      }

      var updateDateValue = function(filterData) {
        var filterStr = null;

        resetTimeToZero(filterData.date);

        if (filterData) {
          filterStr = '';

          switch (filterData.type) {
            case 'day':
              filterStr = toDateString(filterData.date);
              break;
            case 'timeFrame':
              if (filterData.startDate) {
                filterStr = toDateString(filterData.startDate);
              }
              filterStr += ' - ';
              if (filterData.endDate) {
                filterStr += toDateString(filterData.endDate);
              }
              break;
          }
          if (shouldUpdateText) {
            scope.dateSelection = filterStr;
            scope.date = filterData;
          }
        } else {
          scope.dateSelection = null;
          scope.date = null;
        }
        scope.change({ data: { filter: filterData, str: filterStr } });
      };
      scope.showPopup = function() {
        $dialog
          .dialog({
            resolve: {
              data: function() {
                return {
                  options: {
                    show: {
                      day: !shouldHideDaySelector,
                      timeFrame: !shouldHideTimeFrameSelector,
                      none: !shouldHideRemoveSelector
                    }
                  },
                  filter: {
                    type: 'day',
                    date: new Date()
                  }
                };
              }
            }
          })
          .open(
            require('./dateFilterSelectorPopup.html'),
            'dateFilterSelectorPopupController'
          )
          .then(function(exitResult) {
            if (exitResult && exitResult.result === 'ok') {
              var resultingFilter = null;
              if (exitResult.filter.type !== 'none') {
                //fixing this, without touching the underlying implementation as it's to central to be done
                //happens only if user input a string instead of clicking on calendar
                resultingFilter = _.mapObject(exitResult.filter, function(
                  elem
                ) {
                  return _.isNumber(elem) ? new Date(elem) : elem;
                });
              }
              updateDateValue(resultingFilter);
            }
          });
      };
    }
  };
}
